import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import { Link as RouterLink } from "react-router-dom";
import { Link } from "folksam-ui";
import themeOverride from "./themeOverride";
import { ThemeProvider } from "react-jss";

const style = ({ theme }) => ({
  link: {
    color: "#257886",
    "&:hover $icon": {
      fill: theme.colors.linkHover
    }
  },
  icon: {
    lineHeight: 0,
    fill: theme.colors.primary2
  },
  text: {
    fontWeight: "bold",
    lineHeight: 0,
    marginRight: theme.padding["2"],
    fontSize: "14px"
  }
});

const StepHeaderLink = ({ classes, to, children }) => {
  const { t } = useTranslation();
  return (
    <ThemeProvider
      theme={{
        theme: themeOverride
      }}
    >
      <Link to={to} component={RouterLink} className={classes.link}>
        <span className={classes.text}>{t("list.item.change.label")}</span>
      </Link>
    </ThemeProvider>
  );
};

StepHeaderLink.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.any
};

export default injectSheet(style)(StepHeaderLink);
